import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { freeSet } from "@coreui/icons";
import { ToastService } from "angular-toastify";
import { isNil } from "lodash-es";
import { Editor } from "ngx-editor";
import { ApiService } from "src/app/api/api.service";
import { CoreService } from "src/app/services/core-service/core-service.service";
import { StorageService } from "src/app/services/storage.service";
import { Result, parseError } from "src/app/shared/interfaces";

@Component({
    selector: 'app-contacto',
    templateUrl: './contacto.component.html',
    styleUrl: './contacto.component.scss'
})
export class ContactoComponent implements OnInit, OnDestroy {

    icons = freeSet;
    editor: Editor | any;
    html = '';
    formContent = this.fb.group({
        contenido: this.fb.control('', Validators.required)
    })
    private contenidoId = 3;
    private _modoEdicion: boolean = false;

    form = new FormGroup({
        nombres: new FormControl('', Validators.required),
        correo: new FormControl('', { validators: [Validators.required, Validators.email] }),
        mensaje: new FormControl('', { validators: [Validators.required, Validators.min(10)] })
    });

    formaInicial: any = null;

    constructor(
        private ntf: ToastService,
        private api: ApiService,
        private core: CoreService,
        private fb: FormBuilder,
        private storage: StorageService
    ) {
        this.formaInicial = this.form.getRawValue();
        this._modoEdicion = this.storage?.token?.logueado || false;
    }

    ngOnInit(): void {
        this.obtenerContenido();
        this.editor = new Editor();

    }

    async obtenerContenido() {
        try {
            const path = `contenido/${this.contenidoId}`
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            this.formContent.patchValue({ contenido: result.data.contenido })
            this.html = result.data.contenido
        } catch (e) {

        }
    }

    async actualizarContenido() {
        try {
            if (isNil(this.html) || this.html == '') {
                this.ntf.warn(`Ingrese el contenido antes de guardar los cambios.`);
                return;
            }
            const path = `contenido/actualizar/${this.contenidoId}`
            await this.api.consulta(path, true, [], this.formContent.getRawValue(), 'PUT')
            this.obtenerContenido();
            this.ntf.success(`Se actualizo el contenido.`)
        } catch (e) {
            this.ntf.error(`Error: ${parseError(e)}`);
        }
    }

    // make sure to destory the editor
    ngOnDestroy(): void {
        this.editor.destroy();
    }

    async guardar() {
        try {
            this.core.lock()
            const path = "contacto"
            await this.api.consulta(path, false, [], this.form.getRawValue(), 'POST')
            this.ntf.success('Se envio tu informacion correctamente.')
            this.form.reset(this.formaInicial)
        } catch (error) {
            this.ntf.error(`Error: ${parseError(error)}`)
        } finally {
            this.core.unlock()
        }
    }

    get modoEdicion(): boolean {
        return this._modoEdicion;
    }
}